import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import { AuthServerProvider, EditableAccountDTO} from '../../shared';
import {Register} from '../register/register.service';

@Component({
    selector: 'jhi-fc-auth-redirect',
    templateUrl: './fc-auth-redirect.component.html',
    styleUrls: ['./fc-auth-redirect.component.scss']
})
export class FcAuthRedirectComponent implements OnInit {
    constructor(
        private router: Router,
        private register: Register,
        private fcAuthServerProvider: AuthServerProvider
    ) {
    }

    ngOnInit() {
        this.fcUserInfo().subscribe(
            user => {
                if (user.id) {
                    this.router.navigate(['/']);
                } else {
                    this.register.injectFCUser(user);
                    this.router.navigate(['/register/particulier']);
                }
            },
            _ => this.router.navigate(['/authentication'])
        );
    }

    private fcUserInfo(): Observable<EditableAccountDTO> {
        return this.fcAuthServerProvider.fcUserInfo();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/fc-auth-redirect/fc-auth-redirect.component.ts